import React from 'react'
import './Lead.scss'

const Lead = () => {
  return (
    <div style={{height: '80vh' , display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <p>Comming Soon..</p>
    </div>
  )
}

export default Lead